'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactJplayer = require('react-jplayer');
var _reactRedux = require('react-redux');
var _recompose = require('recompose');
var _jPlaylist = require('./jPlaylist');
var _jPlaylist2 = _interopRequireDefault(_jPlaylist);
var _constants = require('../../util/constants');
var _actions = require('../../actions/actions');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var _states;
  var jPlayers = _ref.jPlayers,
    jPlaylists = _ref.jPlaylists;
  var id = _ref2.id;
  return {
    playNow: jPlaylists[id].playNow,
    shuffled: jPlaylists[id].shuffled,
    loop: jPlaylists[id].loop,
    shuffleOnLoop: jPlaylists[id].shuffleOnLoop,
    focused: jPlayers[id].focused,
    playlist: jPlaylists[id].playlist,
    current: jPlaylists[id].current,
    id: id,
    states: (_states = {}, _defineProperty(_states, _constants.classes.states.LOOPED_PLAYLIST, jPlaylists[id].loop === 'loop-playlist'), _defineProperty(_states, _constants.classes.states.SHUFFLED, jPlaylists[id].shuffled), _states)
  };
};
var createProps = function createProps(_ref3) {
  var playlist = _ref3.playlist,
    current = _ref3.current;
  return {
    currentMediaId: playlist.length > 0 ? playlist[current].id : null
  };
};
var handlers = {
  setLoop: function setLoop(props) {
    return function () {
      if (props.loop === 'loop') {
        props.dispatch(_reactJplayer.actions.setOption(props.id, 'loop', true));
      } else {
        props.dispatch(_reactJplayer.actions.setOption(props.id, 'loop', false));
      }
    };
  },
  playNext: function playNext(props) {
    return function () {
      return props.dispatch((0, _actions.next)(props.id));
    };
  },
  playMediaNow: function playMediaNow(props) {
    return function () {
      props.dispatch(_reactJplayer.actions.play(props.id));
      props.dispatch((0, _actions.setOption)(props.id, 'playNow', false));
    };
  },
  changeMedia: function changeMedia(props) {
    return function () {
      if (props.playlist.length > 0) {
        props.dispatch(_reactJplayer.actions.setMedia(props.id, props.playlist[props.current]));
      }
    };
  },
  shufflePlaylistOnLoopPlaylist: function shufflePlaylistOnLoopPlaylist(props) {
    return function () {
      if (props.loop === 'loop-playlist' && props.current === 0 && props.shuffled && props.shuffleOnLoop) {
        props.dispatch((0, _actions.shuffle)(props.id, true, true));
      }
    };
  },
  clearMediaWhenPlaylistEmpty: function clearMediaWhenPlaylistEmpty(props) {
    return function () {
      if (props.playlist.length === 0) {
        props.dispatch(_reactJplayer.actions.clearMedia(props.id));
      }
    };
  }
};
var contextTypes = {
  id: _propTypes2.default.string,
  internalEvents: _propTypes2.default.shape({
    onEnded: _propTypes2.default.func
  })
};
var childContext = function childContext(_ref4) {
  var id = _ref4.id,
    playNext = _ref4.playNext;
  return {
    id: id,
    internalEvents: {
      onEnded: playNext
    }
  };
};
var lifecycle = {
  componentDidMount: function componentDidMount() {
    if (this.props.playlist.length > 0) {
      this.props.dispatch((0, _actions.setPlaylist)(this.props.id, this.props.playlist));
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.props.currentMediaId !== prevProps.currentMediaId) {
      this.props.changeMedia();
    }
    if (this.props.playlist.length !== prevProps.playlist.length) {
      this.props.clearMediaWhenPlaylistEmpty();
    }
    if (this.props.loop !== prevProps.loop) {
      this.props.setLoop();
    }
    if (this.props.playNow) {
      this.props.playMediaNow();
    }
    if (this.props.currentMediaId !== prevProps.currentMediaId && prevProps.current === prevProps.playlist.length - 1) {
      this.props.shufflePlaylistOnLoopPlaylist();
    }
  }
};
exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _recompose.withProps)(createProps), (0, _recompose.withHandlers)(handlers), (0, _recompose.withContext)(contextTypes, childContext), (0, _recompose.lifecycle)(lifecycle))(_jPlaylist2.default);